// extracted by mini-css-extract-plugin
export default {"avatar":"ProfileInfo_avatar__S9v-j","actionButtons":"ProfileInfo_actionButtons__c70KO"};